export interface IPerson {
  id?: string;
  name?: string;
  email?: string | null;
  IsDeleted?: boolean;
}

export const defaultValue: Readonly<IPerson> = {
  IsDeleted: false,
};
